import React, { memo } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';

// Individual flower card component
const FlowerCard = memo(({ flower, onQuantityChange }) => {
  return (
    <Card
      className={`overflow-hidden transition-all duration-300 h-full flex flex-col ${
        flower.quantity > 0 ? 'ring-2 ring-secondary/30 shadow-pastel-md' : ''
      }`}
    >
      <div className="relative h-48 overflow-hidden bg-accent/10">
        {flower.path && (
          <img
            src={flower.path}
            alt={flower.name}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          />
        )}
        <div className="absolute top-2 right-2">
          <span className="inline-block px-2 py-1 text-xs font-medium rounded-soft bg-light/90 text-text-dark">
            {flower.color}
          </span>
        </div>
      </div>

      <div className="p-4 flex-grow flex flex-col">
        <h3 className="font-medium text-lg text-primary mb-1">{flower.name}</h3>
        <p className="text-text-light text-sm mb-3 flex-grow">
          {flower.description ||
            'Beautiful premium quality flower for your home.'}
        </p>
        <div className="text-accent font-medium mb-4">
          ₹{flower.pricePerStem} per stem
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center border border-accent rounded-soft overflow-hidden">
            <button
              onClick={() => onQuantityChange(flower.id, -1)}
              disabled={flower.quantity <= 0}
              className="w-8 h-8 flex items-center justify-center bg-accent/10 text-text-dark disabled:opacity-50 disabled:cursor-not-allowed"
            >
              -
            </button>
            <span className="w-8 h-8 flex items-center justify-center font-medium">
              {flower.quantity}
            </span>
            <button
              onClick={() => onQuantityChange(flower.id, 1)}
              className="w-8 h-8 flex items-center justify-center bg-accent/10 text-text-dark hover:bg-accent/20"
            >
              +
            </button>
          </div>

          <Button
            variant={flower.quantity > 0 ? 'pastel' : 'outline'}
            size="sm"
            onClick={() =>
              flower.quantity === 0 && onQuantityChange(flower.id, 1)
            }
          >
            {flower.quantity > 0 ? 'Added' : 'Add'}
          </Button>
        </div>
      </div>
    </Card>
  );
});

export default FlowerCard;
